<template>
    <BTable :items="value" :fields="tableFields">
        <template v-slot:cell(label)="data">
            <BInput v-model="data.item.label" :disabled="disabled" />
        </template>
        <template v-slot:cell(value)="data">
            <BInput v-model="data.item.value" :disabled="disabled" />
        </template>
        <template v-slot:cell(delete)="data">
            <OmniButton @click="deleteMenuItem(data.index)" icon="trash" variant="danger" class="float-right" :disabled="disabled">{{ $t(`frontend-parameters.parameters.order-details.${parameter.key}.button-remove`) }}</OmniButton>
        </template>

        <template v-slot:bottom-row>
            <td>
                <BFormInput v-model="newMenuItem.label" :placeholder="$t(`frontend-parameters.parameters.order-details.${parameter.key}.label-placeholder`)" :disabled="disabled"></BFormInput>
            </td>
            <td>
                <BFormInput v-model="newMenuItem.value" :placeholder="$t(`frontend-parameters.parameters.order-details.${parameter.key}.value-placeholder`)" :disabled="disabled"></BFormInput>
            </td>
            <td>
                <OmniButton @click="addMenuItem" icon="circle-plus" class="float-right" :disabled="!formValid || disabled">{{ $t(`frontend-parameters.parameters.order-details.${parameter.key}.button-add`) }}</OmniButton>
            </td>
        </template>
    </BTable>
</template>

<script>
import {i18n} from "@/main";

export default {
    name: 'LabelValuePairsInput',

    props: {
        value: {required: true},
        parameter: {required: true },
        disabled: {default: false },
    },

    data() {
        return {
            newMenuItem: { label: '', value: '' },
            tableFields: [
              { key: 'label', label: i18n.t(`frontend-parameters.parameters.order-details.${this.parameter.key}.label`) },
              { key: 'value', label:  i18n.t(`frontend-parameters.parameters.order-details.${this.parameter.key}.value`) },
              { key: 'delete', label: '' }
            ]
          }
    },

    computed: {
        formValid() {
            // Regular expression for ASCII characters
            const asciiRegex = /^[\x00-\x7F]*$/;

            // Check if every property of newMenuItem is not null, not an empty string, not just whitespace, contains only ASCII characters, and has no leading/trailing whitespace
            return Object.keys(this.newMenuItem).every(key => {
                const value = this.newMenuItem[key];
                // Ensure the value is not null and not an empty string after trimming
                if (value === null || value.trim() === '') {
                    return false;
                }

                // Check if the value contains only ASCII characters and has no leading/trailing whitespace
                return value === value.trim() && asciiRegex.test(value);
            });
        },
    },

    methods: {
        addMenuItem() {
            if (this.newMenuItem.label && this.newMenuItem.value) {
                this.value.push({ ...this.newMenuItem });
                this.newMenuItem = { label: '', value: '' }; // Reset input fields
            }
        },
        deleteMenuItem(index) {
            this.value.splice(index, 1);
        },
    }
}
</script>
